export const MenuData = [
    {
        user: "Manager",
        title: "Inicio",
        path: "/mentorias",
        icon: "home"
    },
    {
        user: "Manager",
        title: "Mentores",
        path: "/listaMentores",
        icon: "psychology"
    },
    /* {
        user: "Manager",
        title: "Evaluaciones",
        path: "/listaEvaluaciones",
        icon: "list"
    }, */
    {
        user: "Manager",
        title: "Configuración",
        path: "/perfil",
        icon: "settings"
    },
    {
        user: "Teacher",
        title: "Inicio",
        path: "/mentorias",
        icon: "home"
    },
    {
        user: "Teacher",
        title: "Alumno(s) asignado(s)",
        path: "/alumnosAsignados",
        icon: "home"
    },
    /* {
        user: "Teacher",
        title: "Evaluación",
        path: "/evaluacion",
        icon: "list"
    }, */
    {
        user: "Teacher",
        title: "Editar datos",
        path: "/editTeacher",
        icon: "person"
    },
    {
        user: "Student",
        title: "Inicio",
        path: "/mentorias",
        icon: "home"
    },
    {
        user: "Student",
        title: "Mentor asignado",
        path: "/mentorAsignado",
        icon: "home"
    },
    /* {
        user: "Student",
        title: "Evaluación",
        path: "/evaluacion",
        icon: "list"
    }, */
    {
        user: "Student",
        title: "Editar datos",
        path: "/editStudent",
        icon: "person"
    }
];